import { CommonModule, DatePipe, JsonPipe } from '@angular/common';
import {
  AfterViewInit,
  Component,
  inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import { MatBadgeModule } from '@angular/material/badge';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { MatTableDataSource, MatTableModule } from '@angular/material/table';
import {
  ActivatedRoute,
  Router,
  RouterLink,
  RouterOutlet,
} from '@angular/router';
import { catchError, map, merge, of, startWith, switchMap } from 'rxjs';
import { CartService } from '../../../core/services/cart/cart.service';
import { WebFormDialogBoxComponent } from './web-form-dialog-box/web-form-dialog-box.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { AesEncDecService } from '../../../core/services/aes/aes-enc-dec.service';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatTooltipModule } from '@angular/material/tooltip';
import { WebFormCheckout } from '../../../core/models/checkout/web-form-submit';
import { OrderService } from '../../../core/services/checkout/order.service';
import { DialogComponent } from '../../../shared/components/dialogbox/dialog/dialog.component';
import { MatTabChangeEvent, MatTabsModule } from '@angular/material/tabs';
import { ConfirmDialogBoxComponent } from '../../../shared/components/dialogbox/confirm-dialog-box/confirm-dialog-box.component';
import {
  FormGroup,
  FormBuilder,
  FormControl,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatInputModule } from '@angular/material/input';

@Component({
  selector: 'app-web-form',
  standalone: true,
  imports: [
    MatProgressSpinnerModule,
    MatTableModule,
    RouterOutlet,
    MatSortModule,
    MatInputModule,
    MatPaginatorModule,
    DatePipe,
    RouterLink,
    MatIcon,
    MatBadgeModule,
    MatButtonModule,
    MatFormFieldModule,
    MatTooltipModule,
    MatTabsModule,

    ReactiveFormsModule,
    FormsModule,
    CommonModule,
  ],
  templateUrl: './web-form.component.html',
  styleUrl: './web-form.component.scss',
})
export class WebFormComponent implements AfterViewInit, OnInit {
  poNumber = new FormControl('');
  invoiceEmail = new FormControl('', [
    Validators.required,
    Validators.email,
    Validators.maxLength(60),
  ]);

  private route = inject(ActivatedRoute);
  private cartService = inject(CartService);
  private dialog = inject(MatDialog);
  router = inject(Router);
  resultsLength = 0;
  resultsOrderReviewLength = 0;
  isLoadingResults = true;
  isRateLimitReached = false;

  pageSize = 10;
  pageSizeOrderReview = 10;
  badgeCount: number = 0;
  currentpage: number = 1;
  currentPageOrderReview: number = 1;
  displayedColumns: string[] = ['SNo', 'SKU', 'ItemName', 'Country', 'Action'];
  displayedReviewColumns: string[] = [
    'SNo',
    'SKU',
    'ItemName',
    'deliver_To_First_Name',
    'deliver_To_Last_Name',
    'deliver_To_Email',
    'quantity',
    'responseMessage',
  ];
  maxNumberOfTabs: number = 1;
  reviewOrderData: any = new MatTableDataSource<any>();
  data: any = new MatTableDataSource<any>();
  sNo: number = 0;
  sNoOrderReview: number = 0;
  countryIsoCode: any;
  public badgeCounts: { [sku: string]: number } = {};
  private localStorage = inject(AesEncDecService);
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginatorOrderReview: MatPaginator;
  @ViewChild(MatSort) sortOrderReview: MatSort;
  public products: any[];
  private orderService = inject(OrderService);
  private webFormCheckout = new WebFormCheckout();
  private selectedCountryIsoCode: any;
  selectedIndex: number = 0;
  constructor(private fb: FormBuilder) {}
  ngOnInit(): void {
    this.cartService.getProducts().subscribe((res) => {
      this.products = res;
      this.data.data = this.products;
      this.calculateBadgeCounts();
      this.isLoadingResults = false;
      this.resultsLength = this.products.length > 0 ? this.products.length : 0;
      this.data.paginator = this.paginator;
      this.sNo = this.pageSize * this.currentpage - this.pageSize;
    });
  }
  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => (this.paginator.pageIndex = 0));
    merge(this.sort.sortChange, this.paginator.page).pipe(
      startWith({}),
      switchMap(() => {
        this.isLoadingResults = true;
        this.pageSize = this.paginator.pageSize;
        if (this.paginator.pageIndex == 0) {
          this.currentpage = 1;
        } else {
          this.currentpage = this.paginator.pageIndex + 1;
        }
        return this.cartService.getProducts().pipe(
          map((data) => data as any[]),
          catchError(() => of([] as any[])),
        );
      }),
      map((data) => {
        // Flip flag to show that loading has finished.
        this.isLoadingResults = false;
        this.isRateLimitReached = data.length === 0;
        this.resultsLength =
          this.data.length > 0 ? this.data[0].totalRecords : 0;
        this.data.paginator = this.paginator;
        this.sNo = this.pageSize * this.currentpage - this.pageSize;
        return data;
      }),
    );
  }
  openEditForm(row: any): void {
    const dialogRef = this.dialog.open(WebFormDialogBoxComponent, {
      minWidth: '1000px',
      minHeight: '90%',
      data: {
        sku: row.item_SKU,
        order_item_name: row.item_Name,
        country: row.item_Country_Name,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log('The dialog was closed');
      this.calculateBadgeCounts();
      // Handle the result if needed
    });
  }
  calculateBadgeCounts(): void {
    const storedWebFormDetails = this.localStorage.getData('orderbenificiary');
    let allDetails = [];
    if (storedWebFormDetails) {
      allDetails = JSON.parse(storedWebFormDetails);
    }

    this.badgeCounts = this.products.reduce((acc, product) => {
      const count = allDetails.filter(
        (detail: any) => detail.sku === product.item_SKU,
      ).length;
      acc[product.item_SKU] = count;
      return acc;
    }, {});
  }
  allBadgesGreaterThanZero(): boolean {
    return this.products.every(
      (product) => this.badgeCounts[product.item_SKU] > 0,
    );
  }
  deleteRow(row: any): void {
    const index = this.products.findIndex(
      (product) => product.item_SKU === row.item_SKU,
    );
    this.cartService.removeCartItem(row);
    this.deleteOrderDetail(row);
  }
  deleteOrderDetail(row: any): void {
    // Update local storage after deletion
    const storedWebFormDetails = this.localStorage.getData('orderbenificiary');
    if (storedWebFormDetails) {
      let allDetails = JSON.parse(storedWebFormDetails);
      const detailToRemove = row;
      allDetails = allDetails.filter(
        (detail: any) => !(detail.sku === detailToRemove.item_SKU),
      );
      this.localStorage.saveData(
        'orderbenificiary',
        JSON.stringify(allDetails),
      );
    }
  }
  nextStep() {
    if (this.selectedIndex < 0) this.selectedIndex = 0;
    if (this.selectedIndex != this.maxNumberOfTabs)
      this.selectedIndex = this.selectedIndex + 1;
  }

  previousStep() {
    //  if (this.selectedIndex > 0)
    this.selectedIndex = this.selectedIndex - 1;
  }
  reviewWebFormOrder() {
    const poNumber = this.poNumber.value ? this.poNumber.value : '';
    this.selectedCountryIsoCode =
      (localStorage.getItem('country') as any) || '';
    const loginDetails = JSON.parse(
      (this.localStorage.getData('loginDetails') as any) || '{}',
    );
    const storedWebFormDetails = this.localStorage.getData('orderbenificiary');
    if (storedWebFormDetails) {
      const allDetails = JSON.parse(storedWebFormDetails);
      this.webFormCheckout.clientId = loginDetails[0].cPortalClientDetailsId;
      this.webFormCheckout.poNumber = poNumber;
      this.webFormCheckout.countryISO = this.selectedCountryIsoCode;
      this.webFormCheckout.actionType = 'OrderValidate';
      this.webFormCheckout.orderList = allDetails.map((detail: any) => ({
        sku: detail.sku,
        order_Item_Name: detail.order_item_name,
        deliver_To_Full_Name: detail.deliver_to_full_name,
        deliver_To_First_Name: detail.deliver_to_first_name,
        deliver_To_Last_Name: detail.deliver_to_last_name,
        deliver_To_Email: detail.deliver_to_email,
        quantity: detail.quantity.toString(),
      }));

      console.log('WebFormCheckout:', JSON.stringify(this.webFormCheckout));
      this.orderService.submitWebForm(this.webFormCheckout).subscribe({
        next: (response: any) => {
          this.localStorage.removeData('downloadOrderExcelReport');
          this.localStorage.saveData(
            'downloadOrderExcelReport',
            JSON.stringify(response),
          );
          this.reviewOrderData.data = response.orderList;
          this.isLoadingResults = false;
          this.resultsOrderReviewLength =
            this.reviewOrderData.data.length > 0
              ? this.reviewOrderData.data.length
              : 0;
          this.reviewOrderData.paginatorOrderReview = this.paginatorOrderReview;
          this.sNoOrderReview =
            this.pageSizeOrderReview * this.currentPageOrderReview -
            this.pageSizeOrderReview;
          this.nextStep();
        },
        error: (err) => {
          if (err.error.ResponseMessage) {
            this.dialog.open(DialogComponent, {
              minWidth: '300px',
              data: {
                message: err.error.ResponseMessage,
              },
            });
          }
        },
      });
    }
  }
  openConfirmationBox() {
    const dialogRef = this.dialog.open(ConfirmDialogBoxComponent, {
      minWidth: '300px',
      data: {
        message:
          'Please make sure you have reviewed your order carefully. Are you sure you want to proceed with placing the order?',
      },
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result == true) {
        this.submit();
      } else {
        this.previousStep();
      }
    });
  }
  submit() {
    const poNumber = this.poNumber.value ? this.poNumber.value : '';
     const invoiceEmail = this.invoiceEmail.value ? this.invoiceEmail.value : '';
    this.selectedCountryIsoCode =
      (localStorage.getItem('country') as any) || '';
    const loginDetails = JSON.parse(
      (this.localStorage.getData('loginDetails') as any) || '{}',
    );
    const storedWebFormDetails = this.localStorage.getData('orderbenificiary');
    if (storedWebFormDetails) {
      const allDetails = JSON.parse(storedWebFormDetails);
      this.webFormCheckout.clientId = loginDetails[0].cPortalClientDetailsId;
      this.webFormCheckout.countryISO = this.selectedCountryIsoCode;
      this.webFormCheckout.poNumber = poNumber;
      this.webFormCheckout.invoiceEmail = invoiceEmail;
      this.webFormCheckout.actionType = 'OrderSubmit';
      this.webFormCheckout.orderList = allDetails.map((detail: any) => ({
        sku: detail.sku,
        order_Item_Name: detail.order_item_name,
        deliver_To_Full_Name: detail.deliver_to_full_name,
        deliver_To_First_Name: detail.deliver_to_first_name,
        deliver_To_Last_Name: detail.deliver_to_last_name,
        deliver_To_Email: detail.deliver_to_email,
        quantity: detail.quantity.toString(),
      }));

      console.log('WebFormCheckout:', JSON.stringify(this.webFormCheckout));
      this.orderService.submitWebForm(this.webFormCheckout).subscribe({
        next: (response: any) => {
          this.localStorage.removeData('orderbenificiary');
          this.cartService.removeAllCart();
          this.localStorage.removeData('country');
          this.router.navigate(['order-placed'], {
            queryParams: {
              id: response.orderList[0].order_Number,
              source: 'web',
            },
          });
        },
        error: (err) => {
          if (err.error.ResponseMessage) {
            this.dialog.open(DialogComponent, {
              minWidth: '300px',
              data: {
                message: err.error.ResponseMessage,
              },
            });
          }
        },
      });
    }
  }
  cancelOrder() {
    this.localStorage.removeData('orderbenificiary');
    this.cartService.removeAllCart();
    this.localStorage.removeData('country');
    this.router.navigateByUrl('catalogue-view');
  }

  onTabChange(event: MatTabChangeEvent) {
    this.selectedIndex = event.index;
  }
  getColorClass(value: string): string {
    switch (value) {
      case 'Success':
        return 'high-value';

      default:
        return 'low-value';
    }
  }

  getEmailErrorMessage(): string {
    if (this.invoiceEmail.hasError('required')) {
      return 'Email is required';
    }
    if (this.invoiceEmail.hasError('email')) {
      return 'Please enter a valid email address';
    }
    if (this.invoiceEmail.hasError('maxlength')) {
      return 'Maximum length is 60 characters';
    }
    return '';
  }
}
